import { AppBaseProps, CommonApp } from "../../core/components/commonApp";
import { AppHelper } from "../../appHelper";
import { SheetEventType } from "../../../siteManagement/sheet";
import React from "react";
export class EditTaskMachineApp extends React.Component<EditTaskMachineAppProps, any> {
    common = new AppHelper();
    constructor(props: EditTaskMachineAppProps ) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }
    apply = () => {
        if (this.common.validate()) {
            this.common.setEntityDirtyState(false);
            this.common.sheetWrapper.trigger(SheetEventType.SavedSuccessfully, this.props.entity);
            this.common.sheetWrapper.hide();
        }
    }
    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}


export interface EditTaskMachineAppProps extends AppBaseProps {
    disabled: boolean;
}